import { Link } from 'react-router-dom';
import styles from './Resources.module.css';

export const HerramientasOnline: React.FC = () => {
  const herramientas = [
    {
      id: 1,
      titulo: 'Calculadora de Heredabilidad (h²)',
      descripcion: 'Ingrese varianzas genética, ambiental y fenotípica para calcular heredabilidad en sentido amplio y estricto. Incluye interpretación de resultados según rangos.',
      ecuacion: 'h² = V_A / V_P',
      funcionalidades: [
        'Modo simplificado y avanzado',
        'Cálculo de H² (heredabilidad sentido amplio) y h² (heredabilidad sentido estricto)',
        'Visualización de componentes de varianza',
        'Predictor de respuesta a selección (R = h² × S)',
        '4 ejemplos prácticos precargados',
      ],
      ruta: '/calculadora-heredabilidad',
    },
    {
      id: 2,
      titulo: 'Simulador de Respuesta a Selección',
      descripcion: 'Calcule la ganancia genética esperada (R) a partir de heredabilidad y diferencial de selección. Simule respuesta acumulada en múltiples generaciones.',
      ecuacion: 'R = h² × S o R = i × h × σ_P',
      funcionalidades: [
        'Simulación multi-generacional (hasta 20 generaciones)',
        'Gráfico de evolución de la media poblacional',
        'Tabla detallada por generación',
        'Cálculo de intensidad de selección (i)',
        '4 ejemplos: maíz, soja, trigo, arroz',
      ],
      ruta: '/simulador-seleccion',
    },
    {
      id: 3,
      titulo: 'Calculadora de Coeficiente de Endocría (F)',
      descripcion: 'Determine el nivel de homocigosis después de n generaciones de autofecundación. Visualice la evolución de la endocría en gráficos.',
      ecuacion: 'F_t = 1 - (1 - F_0) × (1/2)^t',
      funcionalidades: [
        'Cálculo de F para cualquier generación',
        'Gráfico dual: homocigosis vs heterocigosis',
        'Barra de progreso visual',
        'Cálculo de generaciones para alcanzar F=0.99',
        'Tabla generación por generación',
      ],
      ruta: '/calculadora-endocria',
    },
    {
      id: 4,
      titulo: 'Estimador de Heterosis',
      descripcion: 'Calcule vigor híbrido (heterosis) a partir de valores medios parentales e híbridos. Compare heterosis absoluta y relativa en diferentes caracteres.',
      ecuacion: 'Heterosis = (F1 - MP) / MP × 100%',
      funcionalidades: [
        'Cálculo de heterosis absoluta y relativa',
        'Análisis multi-carácter',
        'Visualización comparativa de parentales vs. híbridos',
        'Predicción de rendimiento en función de heterosis',
        'Tablas de compatibilidad sexual',
      ],
      ruta: '/estimador-heterosis',
    },
    {
      id: 5,
      titulo: 'Diseñador de Experimentos',
      descripcion: 'Diseñe experimentos agronómicos con diferentes estruturas (DBCA, Diseño Latino, Factorial). Calcule tamaño de muestra y potencia estadística.',
      ecuacion: 'CV% = (EE / media) × 100',
      funcionalidades: [
        'Generador de diseños: completamente aleatorio, DBCA, cuadrado latino',
        'Cálculo de réplicas y tamaño de muestra',
        'Análisis de potencia estadística',
        'Generación de esquemas visuales de campo',
        'Exportación de croquis en PDF',
      ],
      ruta: '/disenador-experimentos',
    },
    {
      id: 6,
      titulo: 'Convertidor de Unidades',
      descripcion: 'Conversión rápida de unidades agronómicas comúnmente utilizadas. Incluye escalas, masas, áreas, rendimientos y concentraciones.',
      ecuacion: 'Conversiones múltiples según factor específico',
      funcionalidades: [
        'Longitud, masa, área, volumen',
        'Rendimientos agrícolas (kg/ha, t/ha, bu/acre)',
        'Concentraciones (%, ppm, mg/kg)',
        'Densidades y presiones',
        'Tabla de factores de conversión descargable',
      ],
      ruta: '/convertidor-unidades',
    },
  ];

  return (
    <div className={styles.resourcesPage}>
      <div className={styles.header}>
        <h2>🧮 Calculadoras y Herramientas Online</h2>
        <p className={styles.subtitle}>
          Herramientas interactivas para cálculos y simulaciones en mejoramiento genético. Cada
          calculadora incluye ejemplos prácticos, visualizaciones interactivas y explicaciones
          detalladas de las fórmulas utilizadas.
        </p>
      </div>

      <div className={styles.resourcesList}>
        {herramientas.map((herramienta) => (
          <div key={herramienta.id} className={styles.resourceItem}>
            <h3 className={styles.itemTitle}>{herramienta.titulo}</h3>
            <p className={styles.itemDescription}>{herramienta.descripcion}</p>

            <div className={styles.itemSection}>
              <p className={styles.ecuacion}>
                <strong>Ecuación:</strong> {herramienta.ecuacion}
              </p>
            </div>

            <div className={styles.itemSection}>
              <h4 className={styles.sectionTitle}>Funcionalidades</h4>
              <ul className={styles.list}>
                {herramienta.funcionalidades.map((func, idx) => (
                  <li key={idx}>{func}</li>
                ))}
              </ul>
            </div>

            <div className={styles.itemFooter}>
              <Link to={herramienta.ruta} className={styles.accessButton}>
                Acceder a la herramienta →
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.notesSection}>
        <h3 className={styles.sectionTitle}>📌 Notas Importantes</h3>
        <div className={styles.notesList}>
          <div className={styles.note}>
            <strong>Validación de datos:</strong> Todas las herramientas validan rangos de entrada
            y previenen errores comunes.
          </div>
          <div className={styles.note}>
            <strong>Exactitud:</strong> Los cálculos utilizan precisión de doble precisión (64
            bits) para máxima exactitud.
          </div>
          <div className={styles.note}>
            <strong>Documentación:</strong> Cada herramienta incluye botón de ayuda con
            explicaciones teóricas detalladas.
          </div>
          <div className={styles.note}>
            <strong>Compatibilidad:</strong> Funcionan en navegadores modernos (Chrome, Firefox,
            Safari, Edge).
          </div>
        </div>
      </div>
    </div>
  );
};
